import base from './base2.repository';
export default {
    getLastVersion: () => base.get('configuration/app-version'),
}


// WEBPACK FOOTER //
// ./src/repositories/app.repository.js